'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { PLCTA } from 'components/performance-lab/PLCTA';
import { useOpenCallbackModal } from 'components/performance-lab/hooks';
import { useRevealOnce } from './useFestiveScrollMotion';
import styles from './FestiveV2Callback.module.css';

/**
 * V2 closing panel (Figma 5324:2482): centred "Not sure which protocol?" with a single
 * Book a callback pill that opens the quick callback form.
 */
export const FestiveV2Callback: React.FC = () => {
  const t = useTranslations('performance-lab');
  const openCallback = useOpenCallbackModal();
  const ref = useRevealOnce<HTMLElement>();

  return (
    <section
      ref={ref}
      className={styles.panel}
      data-festive-callback
      aria-label={t('festive.versions.v2.callback.heading')}
    >
      <div className={styles.copy}>
        <h2 className={styles.heading}>
          {t('festive.versions.v2.callback.heading')}
        </h2>
        <p className={styles.body}>{t('festive.versions.v2.callback.body')}</p>
        <PLCTA
          type="button"
          $plVariant="white"
          className={`${styles.cta} pl-custom-type`}
          onClick={() => openCallback({ flow: 'pl_festive_callback' })}
          data-buttontype="performance_lab_festive_v2_callback"
        >
          {t('festive.versions.hero.cta')}
        </PLCTA>
      </div>
    </section>
  );
};
